export default "__VITE_ASSET__BQyb58KV__"